<template>
  <AnalyticsTemplate 
    page-title="桥梁超高统计"
    chart-type="superelevation"
  />
</template>

<script>
import AnalyticsTemplate from './AnalyticsTemplate.vue'

export default {
  name: 'SuperelevationAnalytics',
  components: {
    AnalyticsTemplate
  }
}
</script>
